const ComparatorUtils = {
    compareByKey(key, order = 'ASC') {
		return function innerSort(a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				return 0;
			}

			const varA = (typeof a[key] === 'string')
				? a[key].toUpperCase() : a[key];
			const varB = (typeof b[key] === 'string')
				? b[key].toUpperCase() : b[key];

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return (
				(order === 'DESC') ? (comparison * -1) : comparison
			);
		};
    },
    compare(a, b) {
		let comparison = 0;
		const valA = a.toUpperCase();
		const valB = b.toUpperCase();
		if (valA > valB) {
			comparison = 1;
		} else if (valA < valB) {
			comparison = -1;
		}
		return comparison;
	},
    sortObject(obj) {
		return Object.fromEntries(
            Object.entries(obj).sort((a, b) => {
                let comparison = 0;
                if (a[1] > b[1]) {
                    comparison = 1;
                } else if (a[1] < b[1]) {
                    comparison = -1;
                }
                return comparison;
            }));
	}
}

export default ComparatorUtils;